module.exports = __webpack_public_path__ + "static/media/iphone-transparent.928cf1c7.png";